import React, { useEffect, useState } from "react";
import logoimg from "../assets/logo.png";
import Select from 'react-select';
import axios from "axios";
import { apiUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";

const NewRegistration = () => {
  let navigate = useNavigate();
    const typedata = [
        {label: "In-Person Classroom", value: "In-Person Classroom"},
        {label: "Live Online Classroom", value: "Live Online Classroom"},
        {label: "Self-Study Online", value: "Self-Study Online"}
    ]
    const [firstname, setfirstname] = useState("");
    const [lastname, setlastname] = useState("");
    const [email, setemail] = useState("");
    const [number, setnumber] = useState("");
    const [address, setaddress] = useState("");
    const [selectedcourse, setselectedcourse] = useState({});
    const [coursesdata, setcoursesdata] = useState([]);
    const [selectedtype, setselectedtype] = useState({});
    const [isselected, setisselected] = useState(false);
    const [showloading, setshowloading] = useState(false); 

    console.log('isselected >>', isselected);

    const fetchproductsbyid = async() => {
        const headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let resp = await axios
          .get(apiUrl + "getallcategories", headers)
          .then((res) => {
            if (res.data.status == "success") {
              
              var prevcoursedata = res.data.coursedata;
              // console.log('prevcoursedata >>>', prevcoursedata);
              var courseoptionsdata = [];
              for(var i = 0; i < prevcoursedata?.length; i++) {
                var obj = {};
                obj['value'] = prevcoursedata[i].title;
                obj['label'] = prevcoursedata[i].title;
                courseoptionsdata.push(obj);
              }
              setcoursesdata(courseoptionsdata);
            } else {
              // alert(res.data.message);
            }
          })
          .catch((err) => {
            alert(err.message);
          });
      }

      const handlesubmitregister = async() => {
        if(isselected) {
            if(firstname && lastname && email && number && address && Object.keys(selectedcourse)?.length > 0 && Object.keys(selectedtype)?.length > 0) {
                setshowloading(true);
                var data = {
                    firstname: firstname,
                    lastname: lastname,
                    email: email, 
                    number: number,
                    address: address,
                    course: Object.keys(selectedcourse)?.length ? selectedcourse?.value : null,
                    type: Object.keys(selectedtype)?.length ? selectedtype?.value : null
                }
                console.log('data >>', data);

                const headers = {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  };

                  let resp = await axios
          .post(apiUrl + "submitregistration",data, headers)
          .then((res) => {
            if (res.data.status == "success") {
                setshowloading(false);
                navigate('/registration-thankyou');
                // Swal.fire({
                //                 title: 'Thank You!',
                //                 text: 'One of our representative will get back to you.',
                //                 icon: 'success',
                //                 customClass: {
                //                   icon: 'custom-swal-icon' // Apply the custom class
                //                 },
                //                 width: '350px',
                //                 confirmButtonText: 'Ok'
                //               });
              
            } else {
              // alert(res.data.message);
              setshowloading(false)
            }
          })
          .catch((err) => {
            alert(err.message);
            setshowloading(false);
          });


                
            } else {
                Swal.fire({
                    // title: 'Not Submitted!!',
                    text: 'Mandatory fields cannot be empty',
                    icon: 'warning',
                    customClass: {
                      icon: 'custom-swal-icon' // Apply the custom class
                    },
                    width: '350px',
                    confirmButtonText: 'Ok'
                  });
            }
        } else {
            Swal.fire({
                            // title: 'Not Submitted!!',
                            text: 'Please Accept terms and conditions before registration.',
                            icon: 'warning',
                            customClass: {
                              icon: 'custom-swal-icon' // Apply the custom class
                            },
                            width: '350px',
                            confirmButtonText: 'Ok'
                          });
        }
      }

      useEffect(() => {
        fetchproductsbyid()
      }, [])
    return (
      <div className="new-register-pagewidth">
        <div className="new-register-logodiv">
          <img src={logoimg} />
        </div>
        <p className="new-register-maintitle">
          Create your account to start application
        </p>
        <div className="new-register-formdiv">
          <div className="row">
            <div className="col-12 col-sm-6">
                <label className="new-register-label">First Name *</label>
              <input
                value={firstname}
                onChange={(t) => {
                  setfirstname(t.target.value);
                }}
                className="form-control new-register-input"
                placeholder="First Name"
              />
            </div>
            <div className="col-12 col-sm-6">
            <label className="new-register-label">Last Name *</label>
              <input
                value={lastname}
                onChange={(t) => {
                  setlastname(t.target.value);
                }}
                className="form-control new-register-input"
                placeholder="Last Name *"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6">
            <label className="new-register-label">Email *</label>
              <input
                value={email}
                onChange={(t) => {
                  setemail(t.target.value);
                }}
                className="form-control new-register-input"
                placeholder="Email *"
              />
            </div>
            <div className="col-12 col-sm-6">
            <label className="new-register-label">Phone Number *</label>
              <input
                value={number}
                onChange={(t) => {
                  setnumber(t.target.value);
                }}
                className="form-control new-register-input"
                placeholder="Phone Number *"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12">
            <label className="new-register-label">Address *</label>
              <textarea
                value={address}
                onChange={(t) => {
                  setaddress(t.target.value);
                }}
                className="form-control new-register-input"
                placeholder="Address *"
                style={{ height: 80 }}
              ></textarea>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12">
            <label className="new-register-label">Course *</label>
              <Select
                value={selectedcourse}
                onChange={setselectedcourse}
                options={coursesdata}
                className="customselect-new-resgister"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12">
            <label className="new-register-label">Learning Type *</label>
              <Select
                value={selectedtype}
                onChange={setselectedtype}
                options={typedata}
                className="customselect-new-resgister"
              />
            </div>
          </div>
          <div className="row">
            <div className="new-register-checkboxdiv">
                <input 
                    type="checkbox" 
                    className="new-register-checkboxinput"
                    value={isselected}
                    onChange={() => {
                        setisselected(!isselected)
                    }}
                 />
                <label className="new-register-label">I agree to receive information regarding my registration for application to Upskills Certifications T&C *</label>
            </div>
          </div>
          <div className="row">
            <div className="new-register-registerbtn" onClick={() => {
                if(showloading) {

                } else {
                    handlesubmitregister();
                }
            }}>
                {
                    showloading ?
                    <Spinner color='#fff' size={15} className='spinnerCenter' /> :
                    <p>Register</p>
                }
                
            </div>
          </div>
        </div>
      </div>
    );
}

export default NewRegistration